/**
 * A capture date ("Read on") is a CALENDAR DAY, not an instant. The form sends `YYYY-MM-DD`, the
 * API stores it as midnight UTC, so it must be read back in UTC too: formatted in local time, a
 * page read on the 23rd shows as the 22nd anywhere west of Greenwich.
 */

/** Today as the reader's LOCAL calendar day. `toISOString()` is UTC, i.e. tomorrow on a US evening. */
export const todayLocal = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** A stored capture date, shown as the day that was entered. */
export const readOnDate = (iso: string | null): string =>
  iso
    ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit', timeZone: 'UTC' })
    : '—'
